import api from '../..'
import { ILessonModel } from 'models/lesson.model'

const createLesson = (data: ILessonModel) => {
  const lesson = { lesson: data }
  return api.post('administration/lessons', lesson)
}
export default createLesson
